/**
 * @file JobFormExtraInitialValuesSlot.tsx
 *
 * @fileoverview This slot is for adding or updating initial values on the job
 * form. For example to add initial values for client's custom fields.
 */
import { User } from '~/jobiqo/models/user';

export interface JobFormExtraInitialValues {
  /**
   * The values to merge into the job form's initial values.
   */
  values: Record<string, any>;
  /**
   * Whether the values are still being resolved.
   */
  loading: boolean;
}

/**
 * Returns extra initial values for the job form.
 *
 * @param user
 *   The current user.
 * @param entity
 *   The job being edited, or undefined when creating one.
 */
export function useJobFormExtraInitialValues(
  user: User | null = null,
  entity?: any,
): JobFormExtraInitialValues {
  return { values: {}, loading: false };
}
